module.exports = __webpack_public_path__ + "img/3991dc5.png";